var __jsx = React.createElement;
import React, { useState } from 'react';
import { useLang } from '@/common/Contexts/LanguageContext';
import { Icon } from "@syarahtech/ui";
import { useTranslation } from "@i18n";
import useIsMobile from "@hooks/useIsMobile";
var FAQSection = function FAQSection() {
  var lang = useLang();
  var isArabic = lang === 'ar';
  var _useState = useState(0),
    activeFaqIndex = _useState[0],
    setActiveFaqIndex = _useState[1];
  var _useState2 = useState(false),
    showAllFaqs = _useState2[0],
    setShowAllFaqs = _useState2[1];
  var _useTranslation = useTranslation(["web_sell_trade"]),
    tShort = _useTranslation.tShort,
    tLong = _useTranslation.tLong;
  var toggleFaq = function toggleFaq(index) {
    setActiveFaqIndex(activeFaqIndex === index ? -1 : index);
  };
  var toggleShowMore = function toggleShowMore() {
    setShowAllFaqs(!showAllFaqs);
    // Reset active FAQ when toggling to avoid confusion
    setActiveFaqIndex(-1);
  };
  var faqs = [{
    question: tShort('faq/question1', {
      ns: 'web_sell_trade'
    }),
    answer: tLong('faq/answer1', {
      ns: 'web_sell_trade'
    })
  }, {
    question: tShort('faq/question2', {
      ns: 'web_sell_trade'
    }),
    answer: tLong('faq/answer2', {
      ns: 'web_sell_trade'
    })
  }, {
    question: tShort('faq/question3', {
      ns: 'web_sell_trade'
    }),
    answer: tLong('faq/answer3', {
      ns: 'web_sell_trade'
    })
  }, {
    question: tShort('faq/question4', {
      ns: 'web_sell_trade'
    }),
    answer: tLong('faq/answer4', {
      ns: 'web_sell_trade'
    })
  }, {
    question: tShort('faq/question5', {
      ns: 'web_sell_trade'
    }),
    answer: tLong('faq/answer5', {
      ns: 'web_sell_trade'
    })
  }, {
    question: tShort('faq/question6', {
      ns: 'web_sell_trade'
    }),
    answer: tLong('faq/answer6', {
      ns: 'web_sell_trade'
    })
  }, {
    question: tShort('faq/question7', {
      ns: 'web_sell_trade'
    }),
    answer: tLong('faq/answer7', {
      ns: 'web_sell_trade'
    })
  }, {
    question: tShort('faq/question8', {
      ns: 'web_sell_trade'
    }),
    answer: tLong('faq/answer8', {
      ns: 'web_sell_trade'
    })
  }, {
    question: tShort('faq/question9', {
      ns: 'web_sell_trade'
    }),
    answer: tLong('faq/answer9', {
      ns: 'web_sell_trade'
    })
  }];

  // Determine which FAQs to display
  var displayedFaqs = showAllFaqs ? faqs : faqs.slice(0, 3);
  var isMobile = useIsMobile();
  return /*#__PURE__*/React.createElement("section", {
    className: "my-12 md:my-[71px] px-5 md:px-4"
  }, /*#__PURE__*/React.createElement("div", {
    className: "mx-auto md:max-w-[566px]"
  }, /*#__PURE__*/React.createElement("h2", {
    className: "text-[28px] font-bold text-[#3c56d4] text-center mb-6 md:mb-5 md:text-[40px]"
  }, tShort('faq/title', {
    ns: 'web_sell_trade'
  })), /*#__PURE__*/React.createElement("h3", {
    className: "text-[24px] font-medium text-[#3C56D4] text-center mb-10 md:mb-8 md:text-[20px]"
  }, tShort('faq/subtitle', {
    ns: 'web_sell_trade'
  })), /*#__PURE__*/React.createElement("div", {
    className: "space-y-3"
  }, displayedFaqs.map(function (faq, index) {
    return /*#__PURE__*/React.createElement("div", {
      className: "bg-[#EDF0FF] rounded rounded-lg overflow-hidden ".concat(activeFaqIndex === index ? 'border border-solid border-[#3c56d4]' : 'border-none'),
      key: index,
      onClick: function onClick() {
        return toggleFaq(index);
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: "p-5 text-4 sm:text-3 sm:line-height-6 focus:border rounded-2 font-bold text-[#3c56d4] cursor-pointer relative transition-all duration-300 ease-in-out text-right rtl:text-right ltr:text-left  sm:p-4"
    }, faq.question, /*#__PURE__*/React.createElement("span", {
      className: "absolute top-1/2 transform -translate-y-1/2 text-[24px] font-bold text-[#3c56d4] right-2 rtl:right-auto rtl:left-2"
    }, activeFaqIndex === index ? /*#__PURE__*/React.createElement(Icon, {
      width: 6,
      height: 6,
      icon: "material-symbols--keyboard-arrow-up-rounded"
    }) : /*#__PURE__*/React.createElement(Icon, {
      width: 6,
      height: 6,
      icon: "material-symbols--keyboard-arrow-down-rounded"
    }))), activeFaqIndex === index && /*#__PURE__*/React.createElement("div", {
      className: "p-[0_20px_20px] text-4 sm:text-3 sm:line-height-4 leading-[1.6] text-[#3c56d4] text-right rtl:text-right ltr:text-left"
    }, faq.answer));
  })), faqs.length > 3 && /*#__PURE__*/React.createElement("button", {
    onClick: toggleShowMore,
    className: "block mx-auto mt-[30px] py-3 px-[30px] bg-[#3C56D4] text-white border-none rounded-[6px] text-[16px] font-semibold cursor-pointer transition-all duration-300 ease-in-out hover:bg-[#2a45c3] hover:translate-y-[-2px] hover:shadow-[0_4px_8px_rgba(0,0,0,0.1)]"
  }, showAllFaqs ? tShort('faq/show_less_button', {
    ns: 'web_sell_trade'
  }) : tShort('faq/show_more_button', {
    ns: 'web_sell_trade'
  }))));
};
export default FAQSection;